import { IAppState } from "../../../app/appTypes"
import { ISpecialty } from "../../../features/specialty/state/specialtyTypes"

export const getAllSpecialties = (state: IAppState): { [id: string]: ISpecialty } => state.entities.specialties.byId

export const getAllSpecialtiesIds = (state: IAppState): string[] => state.entities.specialties.allIds

export const getSpecialtyById = (state: IAppState, id: string): ISpecialty =>  state.entities.specialties.byId[id]
